import React from 'react';
import PropTypes from 'prop-types';
import { emailReg } from 'utils/validators';
import { useForm } from 'react-hook-form';
import { Row, Column } from 'components/shared/Layout';
import styled from 'styled-components';
import { StyledButton } from './ResetPasswordForm.styles';

const StyledForm = styled('form')`
  margin-top: 24px;
`;

const StyledLabel = styled('label')`
  font-weight: bold;
`;

const StyledInput = styled('input')`
  width: 100%;
`;

const StyledError = styled('p')`
  color: red;
  margin: 2px 0;
`;

const ResetPasswordForm = ({ loading, onSubmit }) => {
  const { register, handleSubmit, formState } = useForm();

  const { errors } = formState;

  return (
    <StyledForm onSubmit={handleSubmit(onSubmit)} data-cy="reset-password-form">
      <Row>
        <Row>
          <Column span={16}>
            <StyledLabel htmlFor="username">Username</StyledLabel>
          </Column>
          <Column span={4}>
            <StyledInput id="username" type="text" {...register('username', { required: true })} />
          </Column>
          {errors.username && <StyledError>Please enter a username</StyledError>}
        </Row>

        <Row>
          <Column span={16}>
            <StyledLabel htmlFor="email">Email</StyledLabel>
          </Column>
          <Column span={4}>
            <StyledInput id="email" type="text" {...register('email', { required: true, pattern: emailReg })} />
            {errors.email && <StyledError>Please enter a valid email address</StyledError>}
          </Column>
        </Row>

        <Row>
          <Column>
            <StyledButton disabled={loading} type="submit" variant="primary">
              Submit
            </StyledButton>
          </Column>
        </Row>
      </Row>
    </StyledForm>
  );
};

ResetPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default ResetPasswordForm;
